import React, { Component } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import Login from './screens/Login'
import Home from './screens/Home'
import Add from './screens/Add'
import Edit from './screens/Edit'
import EditMode from './screens/EditMode'
import EditId from './screens/EditId'
import View from './screens/View'
import ViewMode from './screens/ViewMode'
import ViewId from './screens/ViewId'
import NotFound from './screens/404'
import Sidebar from './layout/Sidebar'
import Header from './layout/Header'
import Loading from './components/Loading'
import './App.css'

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loggedIn: false,
      loaded: false,
      user: ''
    }
  }
  componentDidMount () {
    const auth = getAuth()
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.setState({
          loggedIn: true,
          loaded: true,
          user: user
        })
      } else {
        this.setState({
          loggedIn: false,
          loaded: true
        })
      }
    })
  }
  render () {
    if (this.state.loggedIn && this.state.loaded) {
      return (
        <Router>
          <div className='app'>
            <Sidebar user={this.state.user.email} />
            <div className='app__wrapper'>
              <Header />
              <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/add' element={<Add />} />
                <Route path='/edit' element={<Edit />} />
                <Route path='/edit/:mode' element={<EditMode />} />
                <Route path='/edit/:mode/:id' element={<EditId />} />
                <Route path='/view' element={<View />} />
                <Route path='/view/:mode' element={<ViewMode />} />
                <Route path='/view/:id/:group' element={<ViewId />} />
                <Route path='*' element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </Router>
      )
    } else if (!this.state.loggedIn && this.state.loaded) {
      return (
        <Router>
          <div className='app'>
            <Routes>
              <Route path='*' element={<Login />} />
            </Routes>
          </div>
        </Router>
      )
    } else {
      return (
        <div className='app--loading'>
          <Loading />
        </div>
      )
    }
  }
}

export default App
